/* eslint-disable no-extend-native */
import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";

import { createDataAttributes, validateKeys } from "../../utilities";

const FormatDate = ({ date, format, className, dataAttrib }) => {
  // make date into a Date object to test to see if the thing is really a date (in the isNaN below)
  const d = date ? formatDate(date, "DATE") : "";

  const classes = classnames(className, "uikit__date");
  return isNaN(d.valueOf()) ? (
    <span
      className={classnames(classes, "uikit__date__notone")}
      {...createDataAttributes(dataAttrib)}
    >
      {date}
    </span>
  ) : (
    <span className={classes} {...createDataAttributes(dataAttrib)}>
      {formatDate(date, format)}
    </span>
  );
};

FormatDate.propTypes = {
  className: propTypes.string,
  date: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
    propTypes.number,
    propTypes.func
  ]).isRequired,
  format: propTypes.string,
  dataAttrib: propTypes.arrayOf(Object)
};

FormatDate.defaultProps = {
  format: "MM/DD/YYYY"
};

export default FormatDate;

/*
--------------
DATE FORMATTER
--------------
*/
export function formatDate(d, f) {
  if (
    !d || // no date received
    d === "" || // empty string received
    (Object.prototype.toString.call(d) === "[object Object]" &&
      !validateKeys({ $and: ["year", "month", "day"] }, d)) // a quote object is received, but it's not the right kind of date obect (this still allows date objects to pass)
  )
    return "";
  let dateStr = d.toString();

  let format = f ? f.toUpperCase() : null;

  // if it is a simple object like {year: 2000, month: 1, day: 1},
  // then make it a date string -- this is used mostly for quoting data
  dateStr = validateKeys({ $and: ["year", "month", "day"] }, d)
    ? d.month + 1 + "/" + d.day + "/" + d.year
    : dateStr;

  // cleanDateString fixes issue with trying to convert YYYY-MM-DD
  dateStr = cleanDateString(dateStr);

  const isEpoch = typeof d == "number";
  if (isEpoch) dateStr = d;

  if (/\d{4}-\d{2}-\d{2}\s\d{2}:/.test(dateStr)) {
    // IE11 hack for date strings it can't comprehend
    // ----------------------------------------------
    // IE11 won't convert strings like "2000-01-01 00:01:00.000" to a date object
    // but if we update it to "2000-01-01T00:01:00.000", it works fine
    const ie11s = dateStr.match(/(\d{4}-\d{2}-\d{2})(\s)(\d{2}:.+)/);
    dateStr = ie11s[1] + "T" + ie11s[3];
  }

  // if the string has the Zulu tag, remove it so the date isn't calculated to the previous day
  if (/T\d+:\d+:\d+.\d+Z$/.test(dateStr)) {
    dateStr = dateStr.substring(0, dateStr.length - 1);
  }

  const date = new Date(dateStr);

  // setDate to midnight
  date.setHours(0, 0, 0, 0);

  // is it a Date() object?
  // I don't think we need this
  // const isDateObj = d instanceof Date;

  // don't adjust the timezone if the original date is an object
  // or if we're outputting as utc, iso, or epoch
  /* if (
    !(
      isDateObj ||
      format == "UTC" ||
      format == "ISO" ||
      format == "EPOCH" ||
      format == "DATE"
    )
  )
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
*/
  if (!format) return date;

  if (format === "UTC") return date.toUTCString();

  if (format === "ISO") return date.toISOString();

  if (format === "EPOCH") return date.getTime();

  if (format === "DATE") return new Date(date);

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  if (format === "OBJECT")
    return {
      year,
      month: month - 1,
      day
    };

  format = format.replace("DD", date.getDate().toString().padL(2, "0"));
  format = format.replace("D", day);

  format = format.replace("MM", month.toString().padL(2, "0"));
  format = format.replace("M", month);

  format =
    format.indexOf("YYYY") > -1
      ? format.replace("YYYY", year.toString())
      : format.replace("YY", year.toString().substr(2, 2));

  return format;
}

/* FORMAT HELPERS */
String.repeat = function (chr, count) {
  let str = "";
  for (let x = 0; x < count; x++) {
    str += chr;
  }
  return str;
};

String.prototype.padL = function (width, pad) {
  if (!width || width < 1) return this;

  if (!pad) pad = " ";
  const length = width - this.length;
  if (length < 1) return this.substr(0, width);

  return (String.repeat(pad, length) + this).substr(0, width);
};
String.prototype.padR = function (width, pad) {
  if (!width || width < 1) return this;

  if (!pad) pad = " ";
  const length = width - this.length;
  if (length < 1) this.substr(0, width);

  return (this + String.repeat(pad, length)).substr(0, width);
};

const cleanDateString = dateString => {
  // if string is YYYY-MM-DD or YYYY-M-D format, change it to MM/DD/YYYY or M/D/YYYY
  const regTest = /^(\d{4})-(0?[1-9]|1[0-2])-(0?[1-9]|[12]\d|3[01])$/;

  return regTest.test(dateString)
    ? dateString.replace(regTest, "$2/$3/$1")
    : dateString;
};
